import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link2, Sparkles, Share2 } from "lucide-react";

interface HeroRepurposingContentProps {
  onRepurposingClick: () => void;
}

export function HeroRepurposingContent({ onRepurposingClick }: HeroRepurposingContentProps) {

  const steps = [
    {
      number: 1,
      icon: Link2,
      title: "URL einfügen",
      description: "YouTube-Link oder Artikel-URL eingeben"
    },
    {
      number: 2,
      icon: Sparkles,
      title: "KI analysiert",
      description: "Emma & Max erstellen perfekte Posts für jede Plattform"
    },
    {
      number: 3,
      icon: Share2,
      title: "Automatisch posten",
      description: "Ihre Beiträge erscheinen auf LinkedIn, Facebook und Instagram"
    }
  ];

  return (
    <Card 
      className="border-2 border-primary"
      data-testid="card-hero-repurposing-content"
    >
      <CardContent className="pt-6 pb-6 sm:pt-8 sm:pb-8">
        <div className="flex items-start sm:items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
          <Link2 className="w-6 h-6 sm:w-8 sm:h-8 text-primary flex-shrink-0" />
          <h2 className="text-xl sm:text-2xl font-semibold">
            Vom YouTube-Link/Artikel zum perfekten Social Media Post
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-3 mb-6">
          {steps.map((step) => (
            <div key={step.number} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center font-bold flex-shrink-0">
                {step.number}
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <step.icon className="w-4 h-4 text-primary" />
                  <h4 className="font-medium">{step.title}</h4>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed break-words">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-3">
          <Button 
            onClick={onRepurposingClick}
            size="lg"
            className="min-h-[44px]"
            data-testid="button-add-url"
          >
            <Link2 className="w-4 h-4 mr-2" />
            URL hinzufügen
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
